import React, { FC } from "react";
import { Main } from "./elements";

import { LoginForm } from "../../organisms/LoginForm";
import { LoginFormProps } from "../../organisms/LoginForm/LoginForm";

const Login: FC<LoginFormProps> = props => {
  const { onForgotPassword, onLogin, isLoading, innerRef } = props;
  return (
    <Main>
      <LoginForm
        isLoading={isLoading}
        onForgotPassword={onForgotPassword}
        onLogin={onLogin}
        innerRef={innerRef}
      />
    </Main>
  );
};

export default Login;
